import React from 'react';
import DrawerTemplate from '../../components/common/drawer/DrawerTemplate';
import ScrollTop from '../../components/common/footer/ScrollTop';

const MainPage = (props) => {
  return (
   <>
    <div id="back-to-top-anchor"></div>
    <DrawerTemplate/> 
  
    <ScrollTop  {...props} />
   
   </>
  )
};

export default MainPage;
